export default "__VITE_ASSET__BKUE02Vm__"